import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TitleStrategy } from '@angular/router';

import { AppRoutingModule } from './app-routing.module';

// components
import { AppComponent } from './app.component';
import { ToastComponent } from './components/toast/toast.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { MainComponent } from './components/main/main.component';
import { PulseGlobeComponent } from './components/pulse-globe/pulse-globe.component';
import { AuthInterceptor } from './interceptors/auth/auth.interceptor';
import { ErrorInterceptor } from './interceptors/error/error.interceptor';
import { AccountPageComponent } from './pages/account/account.component';
import { DashboardPageComponent } from './pages/dashboard/dashboard.component';
import { LandingPageComponent } from './pages/public/landing/landing.component';
import { ProjectEditorPageComponent } from './pages/project-editor/project-editor.component';
import { ProjectApiKeysPageComponent } from './pages/project-api-keys/project-api-keys.component';
import { ProjectNotificationsPageComponent } from './pages/project-notifications/project-notifications.component';
import { ProjectAnalyticsPageComponent } from './pages/project-analytics/project-analytics.component';
import { ProjectErrorsPageComponent } from './pages/project-errors/project-errors.component';
import { ProjectOverviewPageComponent } from './pages/project-overview/project-overview.component';
import { ProjectAvatarComponent } from './components/project-avatar/project-avatar.component';
import { ProjectErrorDetailPageComponent } from './pages/project-error-detail/project-error-detail.component';
import { ProjectTracingPageComponent } from './pages/project-tracing/project-tracing.component';
import { ProjectTraceDetailPageComponent } from './pages/project-trace-detail/project-trace-detail.component';
import { ProjectStatusPageComponent } from './pages/project-status-page/project-status-page.component';
import { AuthService } from './services/auth.service';

// services
import { AnalyticsService } from './services/analytics.service';
import { ErrorTrackingService } from './services/error-tracking.service';
import { TracingService } from './services/tracing.service';
import { HealthCheckService } from './services/health-check.service';
import { StatusPagesService } from './services/health-pages.service';
import { ProjectManagementService } from './services/project-management.service';
import { SeoTitleStrategy } from './services/seo-title-strategy';
import { UserLoginComponent } from './pages/public/user-login/user-login.component';
import { UserRegisterComponent } from './pages/public/user-register/user-register.component';
import { LegalPageComponent } from './pages/public/legal/legal.component';
import { InvitationComponent } from './pages/public/invitation/invitation.component';
import { RequestAccessComponent } from './pages/public/request-access/request-access.component';
import { OrganizationPageComponent } from './pages/organization/organization.component';
import { TeamsPageComponent } from './pages/teams/teams.component';
import { AdminDashboardPageComponent } from './pages/admin-dashboard/admin-dashboard.component';
import { UserForgotPasswordComponent } from './pages/public/user-forgot-password/user-forgot-password.component';
import { UserResetPasswordComponent } from './pages/public/user-reset-password/user-reset-password.component';

@NgModule({
  exports: [
  ],
  declarations: [
    AppComponent,
    ToastComponent,
    ProjectEditorPageComponent,
    ProjectOverviewPageComponent,
    ProjectAvatarComponent,
    ProjectApiKeysPageComponent,
    ProjectNotificationsPageComponent,
    AccountPageComponent,
    MainComponent,
    FooterComponent,
    HeaderComponent,
    UserRegisterComponent,
    LegalPageComponent,
    InvitationComponent,
    RequestAccessComponent,
    OrganizationPageComponent,
    TeamsPageComponent,
    ProjectStatusPageComponent,
    UserLoginComponent,
    LandingPageComponent,
    DashboardPageComponent,
    ProjectAnalyticsPageComponent,
    ProjectErrorsPageComponent,
    ProjectErrorDetailPageComponent,
    ProjectTracingPageComponent,
    ProjectTraceDetailPageComponent,
    AdminDashboardPageComponent,
    UserForgotPasswordComponent,
    UserResetPasswordComponent,
  ],
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    PulseGlobeComponent,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: TitleStrategy, useClass: SeoTitleStrategy },
    HealthCheckService,
    StatusPagesService,
    AuthService,
    ProjectManagementService,
    AnalyticsService,
    ErrorTrackingService,
    TracingService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
